// extracted by mini-css-extract-plugin
export var arrow = "_bz-2";
export var label = "_bz-1";
export var reminder = "_bz-0";